<template>
    <div v-if='show' class='fixed absolute--fill bg-black o-80 z-1'></div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        }
    }
};
</script>
